"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: {
            display: 'flex',
            alignItems: 'center',
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
        },
        header: {
            flexGrow: 1,
        },
        title: {
            fontWeight: 800,
        },
    });
});
